import icon from "../../assets/alignment.svg";
import type { Property } from "../../types";

export const extendedRangeMode6Ghz: Property = {
  id: "extendedRangeMode6Ghz",
  title: "extendedRangeMode6Ghz.title",
  icon,
};
